<template>
  <div class="home_wrap">
    <van-nav-bar
      :title="title"
      left-text=""
      left-arrow
      :fixed="true"
      @click-left="onClickLeft"
    />
    <div class="art" v-html="content"></div>
  </div>
</template>
  <script>
import Vue from "vue";
// import Fetch from "../../utils/fetch";
import { NavBar } from "vant";
Vue.use(NavBar);
export default {
  name: "articleContent",
  components: {},
  data() {
    return {
      content: "",
      title: "",
    };
  },
  created() {},
  beforeDestroy() {},
  mounted() {
    let data = this.$route.query;
    if (data) {
      this.content = this.$route.query.content;
      this.content = this.content
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")

        .replace(/&amp;/g, "&")
        .replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'");
      this.title = this.$route.query.title;
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push("/activity");
    },
  },
};
</script>
  
  <style lang="less" scoped>
@import "../../assets/css/variables.less";
/deep/ .van-nav-bar {
  background: @secondary-color;
}

/deep/ .van-nav-bar .van-icon {
  color: #fff;
}

/deep/ .van-nav-bar__title {
  color: #fff;
}
.art {
  width: 100%;
  padding: 0.2rem;
  box-sizing: border-box;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
</style>
  